import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr'
import {
  FLAG_GETTING_LEGAL_MANIFEST_CARGOS,
  GET_LEGAL_MANIFEST_CARGOS,
  CLEAR_LEGAL_MANIFEST_CARGOS
} from '../types'

import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { LEGAL_MANIFEST_CARGO_ENDPOINT } from '../../config/endpoints';
import printCargoItemManifest from '../../utils/printers/ItineraryManifest';
import { getManifestCargoItemById } from '../cargo/ItineraryManifest';

const flagGettingManifestCargos = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LEGAL_MANIFEST_CARGOS,
    payload: flag
  });

const clearLegalManifestCargos = () => (dispatch) =>
  dispatch({
    type: CLEAR_LEGAL_MANIFEST_CARGOS
  });

const getLegalManifestCargos = async (filters) => async (dispatch) => {
  try {
    dispatch(flagGettingManifestCargos(true));
    const query = filters;
    const url = `${LEGAL_MANIFEST_CARGO_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const legalManifestCargos = await response.json();
    dispatch({
      type: GET_LEGAL_MANIFEST_CARGOS,
      payload: legalManifestCargos
    });
  } catch (error) {
    toastr.error('Error', error.message);
  }
  finally {
    dispatch(flagGettingManifestCargos(false));
  }
}

const getLegalManifestCargoDetail = async (params) => async () => {
  try {
    const query = QueryString.stringify(params);
    const url = `${LEGAL_MANIFEST_CARGO_ENDPOINT}/detail?${query}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    const legalManifestCargoDetail = await response.json();
    return legalManifestCargoDetail;
  } catch (error) {
    toastr.error('Error', error.message);
    return [];
  }
}

const generateManifestCargoFile = async (id) => async (dispatch) => {
  try {
    dispatch(flagGettingManifestCargos(true));
    const response = await dispatch(getManifestCargoItemById(id));
    printCargoItemManifest(response);
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingManifestCargos(false));
  }
}

const getManifestCargoExportExcel =
  async (idSourceSystem) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingManifestCargos(true));
        const url = `${LEGAL_MANIFEST_CARGO_ENDPOINT}/${idSourceSystem}/actions/export-excel`;
        const response = await fetch(url, DEFAULT_GET_CONFIG);
        await isErrorResponse(response);
        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = "MANIFESTO_CARGA";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagGettingManifestCargos(false));
      }
    };


export {
  flagGettingManifestCargos,
  getLegalManifestCargos,
  getLegalManifestCargoDetail,
  clearLegalManifestCargos,
  generateManifestCargoFile,
  getManifestCargoExportExcel
};
